import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { catchResponse, prepareFetchRequest } from './common.service';
import { ILocale } from './localize.service';
import { IResAccounts, IResAttributes, IResHolders, ISumTotal } from './response.interface';


export const holderAPI = createApi({
  reducerPath: 'holderAPI',
  baseQuery: fetchBaseQuery(prepareFetchRequest()),
  tagTypes: ['holder', 'accounts', 'attributes'],
  endpoints: (build) => ({
    /* Получение клиентов */
    fetchAllClients: build.query<IResHolders, { locale: ILocale }>({
      async queryFn({ locale }, { getState, dispatch }, extraOptions, fetchWithBQ) {

        const result = await fetchWithBQ({
          url: `/holders`,
          params: {
            lang: locale,
          },
        });

        catchResponse({ data: result.data, meta: result.meta, getState, dispatch });

        const data = result.data as IResHolders;

        return { data };

      },
    }),

    /* Получение счетов клиента */
    fetchAccountsClient: build.query<IResAccounts, { locale: ILocale; holderId: number }>({
      async queryFn({ locale, holderId }, { getState, dispatch }, extraOptions, fetchWithBQ) {

        const result = await fetchWithBQ({
          url: `/holders/${holderId}/accounts`,
          params: {
            lang: locale,
          },
        });

        catchResponse({ data: result.data, meta: result.meta, getState, dispatch });
        let data = result.data as IResAccounts;

        let sumTotalBalance: ISumTotal = {
          totalBalance: 0,
          totalBalanceWithoutOverdraft: 0,
          totalOverdraft: 0,
        };

        data = {
          ...data,
          accounts: data.accounts.map(account => {

            const totalBalance = account.totalBalance + account.overdraft;

            sumTotalBalance.totalBalance += totalBalance;
            sumTotalBalance.totalOverdraft += account.overdraft;
            sumTotalBalance.totalBalanceWithoutOverdraft += account.totalBalance;

            return ({
              ...account,
              totalBalance,
              totalBalanceWithoutOverdraft: account.totalBalance,
            });
          }),
          sumTotal: sumTotalBalance,
        };

        return { data };

      },


    }),

    /* Получение аттрибутов клиента */
    fetchAttributesClient: build.query<IResAttributes, { locale: ILocale; holderId: number }>({
      async queryFn({ locale, holderId }, { getState, dispatch }, extraOptions, fetchWithBQ) {

        const result = await fetchWithBQ({
          url: `/holders/${holderId}/attributes`,
          params: {
            lang: locale,
          },
        });

        catchResponse({ data: result.data, meta: result.meta, getState, dispatch });

        const data = result.data as IResAttributes;

        return { data };
      },

    }),

  }),
});

